<mat-dialog-content>
    <app-position-editor readOnly="true" [readOnlyPositionId]="positionId"></app-position-editor>
</mat-dialog-content>

<mat-dialog-actions>
    <button mat-raised-button appPreventDoubleClick (throttledClick)="close()">Close</button>
</mat-dialog-actions>